const handler = ( $ ) => {

	/**
	 * Custom Lightbox HTML: Move close button to Video's container
	 */

	const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
		<div class="gloader visible"></div>
		<div class="goverlay"></div>
		<div class="gcontainer">
		<div id="glightbox-slider" class="gslider"></div>
		<button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example">{nextSVG}</button>
		<button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>
	</div>
	</div>`;

	let customSlideHTML = `<div class="gslide">
		<div class="gslide-inner-content">
			<div class="ginner-container">
				<div class="gslide-media">
					<button class="gclose gbtn" tabindex="2" onClick="javascript:window.lightbox.close();"></button>
				</div>
				<div class="gslide-description">
					<div class="gdesc-inner">
						<h4 class="gslide-title"></h4>
						<div class="gslide-desc"></div>
					</div>
				</div>
			</div>
		</div>
	</div>`;

	// Lightbox
	window.lightbox = GLightbox({
		lightboxHTML: customLightboxHTML,
		slideHTML: customSlideHTML,
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
		videosWidth: '1196px'
	});

};

( ( $ ) => {
	$( handler );
} )( jQuery );
